var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralIconsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.433,
    height: 16.505,
    viewBox: "0 0 21.433 16.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.57-17.088-15.9-4.757-20.43-9.288a.563.563,0,0,0-.8,0l-1.326,1.326a.563.563,0,0,0,0,.8L-16.3-.912a.563.563,0,0,0,.8,0L-1.448-14.966a.562.562,0,0,0,0-.8l-1.326-1.326A.563.563,0,0,0-3.57-17.088Z",
    transform: "translate(22.716 17.252)",
    fill: "#fdba30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsCheck);
export default __webpack_public_path__ + "static/media/generalIcons_Check.84d2cbdd.svg";
export { ForwardRef as ReactComponent };